import { ref } from 'vue';

const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

const isDarkMode = ref(mediaQuery.matches);

const updateDarkMode = (e: MediaQueryListEvent) => {
    isDarkMode.value = e.matches;
};

mediaQuery.addEventListener('change', updateDarkMode);

window.addEventListener('beforeunload', () => {
    mediaQuery.removeEventListener('change', updateDarkMode);
});

export default isDarkMode;
